var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 96,
    viewBox: "0 0 85 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4059 41.278V37.0745C33.4059 35.9478 32.9583 34.8672 32.1616 34.0705C31.3649 33.2738 30.2843 32.8262 29.1576 32.8262H8.30365C7.17722 32.8266 6.09708 33.2744 5.30074 34.0711C4.50439 34.8678 4.05704 35.9481 4.05704 37.0745V91.7514C4.05704 92.8782 4.50463 93.9588 5.30135 94.7555C6.09807 95.5522 7.17865 95.9998 8.30538 95.9998H80.2204C81.3471 95.9998 82.4277 95.5522 83.2244 94.7555C84.0211 93.9588 84.4687 92.8782 84.4687 91.7514V49.7764C84.4687 48.6497 84.0211 47.5691 83.2244 46.7724C82.4277 45.9757 81.3471 45.5281 80.2204 45.5281H37.6508C36.5244 45.5272 35.4444 45.079 34.6484 44.282C33.8524 43.485 33.4055 42.4045 33.4059 41.278Z",
    fill: "#9DA9B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7387 0.000936828L33.1767 0.0941693C32.8759 0.0947467 32.6325 0.339047 32.6331 0.639829L32.7515 62.2898C32.7521 62.5906 32.9964 62.8339 33.2971 62.8333L81.8591 62.7401C82.1599 62.7395 82.4033 62.4952 82.4027 62.1945L82.2843 0.544505C82.2838 0.243723 82.0395 0.00035937 81.7387 0.000936828Z",
    fill: "#F4F5F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9298 21.1002L43.446 21.1626L43.4479 22.1364L75.9317 22.074L75.9298 21.1002Z",
    fill: "#9DA9B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9382 25.5024L37.7704 25.5757L37.772 26.3771L75.9398 26.3038L75.9382 25.5024Z",
    fill: "#9DA9B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9457 30.313L37.7779 30.3862L37.7794 31.1876L75.9472 31.1144L75.9457 30.313Z",
    fill: "#9DA9B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9576 35.5688L37.7899 35.6421L37.7914 36.4435L75.9592 36.3702L75.9576 35.5688Z",
    fill: "#9DA9B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8233 40.8938L37.7999 40.9399L37.8015 41.7414L61.8248 41.6952L61.8233 40.8938Z",
    fill: "#9DA9B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.985 49.8901L37.8173 49.9634L37.8188 50.7648L75.9866 50.6915L75.985 49.8901Z",
    fill: "#24DB57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9943 54.7006L37.8265 54.7739L37.828 55.5753L75.9958 55.5021L75.9943 54.7006Z",
    fill: "#24DB57"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0045 59.9575L37.8367 60.0308L37.8382 60.8322L76.006 60.7589L76.0045 59.9575Z",
    fill: "#24DB57"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0329 4.95292L37.5035 5.02881L37.5274 17.4464L77.0567 17.3705L77.0329 4.95292Z",
    fill: "#FAD7B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6004 37.1506L63.7344 37.1733L63.7566 48.7516L75.6226 48.7288L75.6004 37.1506Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3489 41.278V37.0745C29.3489 35.9478 28.9013 34.8672 28.1046 34.0705C27.3079 33.2738 26.2273 32.8262 25.1005 32.8262H4.24662C3.12019 32.8266 2.04005 33.2744 1.2437 34.0711C0.447355 34.8678 -9.26917e-08 35.9481 0 37.0745L0 91.7514C0 92.8782 0.447592 93.9588 1.24431 94.7555C2.04103 95.5522 3.12161 95.9998 4.24834 95.9998H76.1634C77.2901 95.9998 78.3707 95.5522 79.1674 94.7555C79.9641 93.9588 80.4117 92.8782 80.4117 91.7514V49.7764C80.4117 48.6497 79.9641 47.5691 79.1674 46.7724C78.3707 45.9757 77.2901 45.5281 76.1634 45.5281H33.5938C32.4673 45.5272 31.3874 45.079 30.5914 44.282C29.7953 43.485 29.3484 42.4045 29.3489 41.278Z",
    fill: "#D7DCE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.39d17963a8a9ebbea4144ed08102feeb.svg";
export { ForwardRef as ReactComponent };